import script from "./UserRolesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRolesPage.vue?vue&type=script&setup=true&lang=js"

import "./UserRolesPage.vue?vue&type=style&index=0&id=f913e3ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f913e3ea"]])

export default __exports__